import type { Routes } from '../route-levels.ts';
import { numberFlag } from './builders.ts';
import type { NumberFlagDefinition } from './types.ts';

/**
 * The system flag of each route in `routes`, keyed by route name.
 *
 * Each flag:
 * - Is keyed `portal-config.routes.<name>`.
 * - Is a number flag whose default is the route's level.
 *
 * A route that `routes` leaves out has no flag, so no system flag can raise it.
 */
export function createRouteFlags(routes: Routes): Record<string, NumberFlagDefinition> {
  const flags: Record<string, NumberFlagDefinition> = {};
  for (const [name, level] of Object.entries(routes)) {
    flags[name] = numberFlag(`portal-config.routes.${name}`, level);
  }
  return flags;
}
